/**
 * Ecosystem map
 */
var component_ecosystem_map = function(args) {

  // setup args
  var filters = args.element.querySelector('.ecosystem-map__filters');
  var facets = filters.querySelectorAll('.facetwp-facet');

  // checks if there are active facet filters
  function checkIfFiltered(facets) {
    let filtered = false;

    facets.forEach(facet => {
      if (Object.getOwnPropertyDescriptor(FWP.facets, facet.dataset.name).value.length >= 1) {
        filtered = true;
      }
    });

    return filtered;
  }

  if (filters) {
    var resetBtn = filters.querySelector('.ecosystem-map__reset-filters');

    (function($) {
      $(document).on('facetwp-loaded', function() {
        filters.querySelector('.ecosystem-map__results-count').innerHTML = FWP.settings.pager.total_rows + ' ' + translations.str_results;

        // Show reset button only if there is selected filters
        if (checkIfFiltered(facets)) {
          resetBtn.classList.add('visible');
        } else {
          resetBtn.classList.remove('visible');
        }

        /**
         * Init a11y-dialogs after facetwp load
         */
        var a11y_dialogs = document.querySelectorAll('.a11y-dialog');
        for (var i = 0; i < a11y_dialogs.length; i++) {
          component_a11y_dialog({
            dialog: a11y_dialogs[i]
          });
        }

        /**
         * Remove aria-label attributes from facetwp checkboxes
         * and add aria-hidden="true" to counts in them
         *
         * (wait 200 ms to prevent facetwp javascript overriding)
         */
        setTimeout(function() {
          var checkboxes = filters.querySelectorAll('.facetwp-checkbox');
          for (var i = 0; i < checkboxes.length; i++) {
            // remove aria-label
            checkboxes[i].removeAttribute('aria-label');
            // add aria-hidden to count
            checkboxes[i].querySelector('.facetwp-counter').setAttribute('aria-hidden', true);
          }
        }, 200);
      });
    })(jQuery);
  }

  // make the call chainable
  return this;

};

